// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MessageSquareOutlinedSvg from "@fishx/icons-svg/es/asn/MessageSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var MessageSquareOutlined = function MessageSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MessageSquareOutlinedSvg
  }));
};

MessageSquareOutlined.displayName = 'MessageSquareOutlined';
export default React.forwardRef(MessageSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MessageSquareOutlined.js
// module id = 3127
// module chunks = 0